<div class="profile-card" *ngIf="emp && emp.user && !enlargeImage">
  <!-- Header Section -->
  <div class="profile-header">
    <div class="avatar-container" *ngIf="showImage">
      <div class="avatar-wrapper" (click)="emp.user.url ? enlargeImage=true : null">
        <img [src]="emp.user.url" *ngIf="emp.user.url">
        <img src="./assets/imgs/male.png" *ngIf="!emp.user.url && emp.user.gender=='MALE'">
        <img src="./assets/imgs/female.png" *ngIf="!emp.user.url && emp.user.gender!='MALE'">
      </div>
    </div>
  </div>

  <!-- Body Section -->
  <div class="profile-body">
    <!-- Name and Status -->
    <div class="profile-name-section">
      <h2>
        <span *ngIf="emp.user.user_pd.death_date">{{'Late' | translate}}. </span>
        {{emp.user.name}} {{emp.user.last_name || ''}}
        <ion-icon
          [color]="emp.user.user_pd.status=='Joined'?'medium':emp.user.user_pd.status=='Rejected'?'danger':'success'"
          name="checkmark-circle" class="verify-badge" *ngIf="emp.user.user_pd.status">
        </ion-icon>
      </h2>
      <span class="caste-text">{{emp.user.user_pd.caste}}</span>

      <ion-button
        *ngIf="auth.loggedInEmployee.assigned_area && ((auth.loggedInEmployee.assigned_area+'').length>2) && emp.user.user_pd.status=='Joined'"
        size="small" color="secondary" class="verify-button" (click)="empService.clickApprove(emp)">
        {{'Verify Profile' | translate}}
      </ion-button>
    </div>

    <!-- Info Sections -->
    <div class="info-section">
      <!-- Personal Details -->
      <div class="section-title">{{'Personal Details' | translate}}</div>
      <div class="info-grid">
        <div class="info-item">
          <div class="icon-wrapper"><ion-icon name="person-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Gender' | translate}}</span>
            <span class="item-value">{{emp.user.gender | translate}}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="icon-wrapper"><ion-icon name="calendar-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Birth Date' | translate}}</span>
            <span class="item-value">{{emp.user.dob | fancyDateOnly}}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="icon-wrapper"><ion-icon name="heart-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Marital Status' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.marital | translate}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.blood">
          <div class="icon-wrapper"><ion-icon name="water-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Blood Group' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.blood}}</span>
          </div>
        </div>
      </div>

      <!-- Professional Details -->
      <div class="section-title">{{'Professional Details' | translate}}</div>
      <div class="info-grid">
        <div class="info-item" *ngIf="emp.user.user_pd.occupation">
          <div class="icon-wrapper"><ion-icon name="briefcase-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Occupation' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.occupation | translate}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.profession">
          <div class="icon-wrapper"><ion-icon name="medal-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Profession' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.profession | translate}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.education">
          <div class="icon-wrapper"><ion-icon name="school-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Education' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.education | translate}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.department">
          <div class="icon-wrapper"><ion-icon name="business-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Department' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.department | translate}}</span>
          </div>
        </div>
      </div>

      <!-- Community Details -->
      <div class="section-title">{{'Community Details' | translate}}</div>
      <div class="info-grid">
        <div class="info-item" *ngIf="emp.user.user_pd.sub_community">
          <div class="icon-wrapper"><ion-icon name="people-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Sub Community/Gotra/Khap/Pur' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.sub_community}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.origin_city">
          <div class="icon-wrapper"><ion-icon name="home-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Place of Origin' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.origin_city}}</span>
          </div>
        </div>
        <div class="info-item" *ngIf="emp.user.user_pd.tag && emp.user.user_pd.tag.length > 0">
          <div class="icon-wrapper"><ion-icon name="pricetags-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Tags' | translate}}</span>
            <div class="item-value">
              <ion-badge color="primary" *ngFor="let item of emp.user.user_pd.tag" mode="ios" class="badge-tag">
                {{item}}
              </ion-badge>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact & Location -->
      <div class="section-title">{{'Contact & Location' | translate}}</div>
      <div class="info-grid">
        <!-- Mobile (Conditional Visibility) -->
        <div class="info-item"
          *ngIf="emp?.user?.user_pd?.privacy=='Open to connect' || emp?.user?.id === auth?.loggedInEmployee?.user?.id || (auth?.loggedInEmployee?.assigned_area && emp?.user?.user_pd?.status=='Joined')">
          <div class="icon-wrapper"><ion-icon name="call-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Mobile' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.mobile}}</span>
          </div>
          <div class="contact-actions"
            *ngIf="auth.loggedInEmployee.assigned_area && ((auth.loggedInEmployee.assigned_area+'').length>2) && emp.user.user_pd.mobile">
            <a class="action-btn" [href]="'tel:'+emp.user.user_pd.country_code+emp.user.user_pd.mobile">
              <ion-icon name="call"></ion-icon>
            </a>
            <div class="action-btn"
              (click)="whatsapp.sendMessage(emp.user.user_pd.country_code+emp.user.user_pd.mobile, '')">
              <ion-icon name="logo-whatsapp" style="color: #25d366;"></ion-icon>
            </div>
          </div>
        </div>

        <div class="info-item" *ngIf="emp.user.user_pd.email && emp.user.user_pd.privacy=='Open to connect'">
          <div class="icon-wrapper"><ion-icon name="mail-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Email' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.email}}</span>
          </div>
        </div>

        <div class="info-item" *ngIf="emp.user.user_pd.current_address2">
          <div class="icon-wrapper"><ion-icon name="location-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Location' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.current_address2}}</span>
          </div>
        </div>

        <div class="info-item" *ngIf="emp.user.user_pd.permanent_address">
          <div class="icon-wrapper"><ion-icon name="map-outline"></ion-icon></div>
          <div class="item-content">
            <span class="item-label">{{'Permanent Address' | translate}}</span>
            <span class="item-value">{{emp.user.user_pd.permanent_address}}</span>
          </div>
        </div>
      </div>

      <!-- Achievements Section -->
      <div class="achievement-card" *ngIf="emp.user.user_pd.achievement && emp.user.user_pd.achievement.length > 0">
        <div class="achievement-header">
          <ion-icon name="trophy"></ion-icon>
          {{'Achievements & Posts' | translate}}
        </div>
        <div *ngFor="let item of emp.user.user_pd.achievement">
          <div class="achievement-item" *ngFor="let key of objectKeys(item)">
            <span class="key">{{key}}</span>
            <span class="value">{{item[key]}}</span>
          </div>
        </div>
      </div>

      <!-- Creator Info -->
      <div class="creator-info" *ngIf="showCreator">
        <div *ngIf="creator">
          {{'Entry created by' | translate}} <a (click)="emp=creator">{{creator.user.name}} Ji</a>
        </div>
        <div *ngIf="verifier" style="margin-top: 5px;">
          {{'Entry Verified by' | translate}} <a (click)="emp=verifier">{{verifier.user.name}} Ji</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Overlay -->
<div *ngIf="enlargeImage" class="fullscreen-overlay" (click)="enlargeImage=false">
  <ion-icon name="close-circle" class="close-btn"></ion-icon>
  <img [src]="emp.user.url">
</div>